import React, { useState, useEffect } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { fetchFacilityDistribution } from '../../data/api';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const FacilityDistributionChart = () => {
  const [dist, setDist] = useState({ above_90: 0, pct_75_90: 0, pct_50_75: 0, below_50: 0 });

  useEffect(() => {
    fetchFacilityDistribution().then(r => setDist(r.data)).catch(console.error);
  }, []);

  const data = {
    labels: ['> 90%', '75-90%', '50-75%', '< 50%'],
    datasets: [{
      data: [Number(dist.above_90), Number(dist.pct_75_90), Number(dist.pct_50_75), Number(dist.below_50)],
      backgroundColor: ['#27ae60','#f39c12','#e67e22','#e74c3c'],
      borderWidth: 2, borderColor: '#fff'
    }]
  };

  const options = {
    responsive: true, maintainAspectRatio: false,
    plugins: {
      legend: { position: window.innerWidth < 600 ? 'top' : 'right', labels: { boxWidth: 12, font: { size: 10, weight: '600' }, padding: 10 } },
      datalabels: {
        display: true, color: '#fff', font: { weight: '700', size: 10 },
        formatter: (v, ctx) => {
          const total = ctx.chart.data.datasets[0].data.reduce((a,b) => a+b, 0);
          return total > 0 ? (v/total*100).toFixed(0) + '%' : '0%';
        }
      }
    }
  };

  return (
    <div className="chart-box">
      <h3>Facility Distribution by Stock Level</h3>
      <div style={{ position: 'relative', minHeight: '300px' }}>
        <Doughnut data={data} options={options} />
      </div>
    </div>
  );
};

export default FacilityDistributionChart;
